<ng-container [formGroup]="form">
  <div
    class="content-item-wrapper"
    [class.slide-out-panel-active]="activeSlideOutPanel$ | async"
    [class.active-locked]="link.active_locked"
  >
    <div class="drag-handle-container">
      <button type="button" mat-icon-button cdkDragHandle>
        <mat-icon svgIcon="drag-indicator"></mat-icon>
      </button>
    </div>
    <div class="content-item-body">
      <div class="header">
        <div class="title">{{ link.name }}</div>
        <mat-slide-toggle formControlName="active"></mat-slide-toggle>
      </div>
      <div class="subheader">
        <img class="favicon-img" [src]="link.image" *ngIf="link.image" alt="" />
        <img class="favicon-img" [src]="link.long_url | favicon" *ngIf="!link.image" alt="" />
        <span class="url">{{ link.long_url }}</span>
      </div>
      <div class="actions">
        <button
          type="button"
          (click)="openEditLinkDialog()"
          [disabled]="editor.loading$ | async"
          class="action-button"
          [matTooltip]="'Edit' | trans"
          mat-icon-button
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button
          type="button"
          (click)="toggleAnimationPanel('image')"
          [disabled]="editor.loading$ | async"
          class="action-button image-action-btn"
          mat-icon-button
          [matTooltip]="'Change Thumbnail' | trans"
          [class.active]="imageActive$ | async"
        >
          <mat-icon svgIcon="image"></mat-icon>
        </button>
        <a
          [routerLink]="['/', getParentRoute(), 'links', link.id]"
          target="_blank"
          [disabled]="editor.loading$ | async"
          class="action-button"
          mat-icon-button
          [matTooltip]="'Statistics' | trans"
        >
          <mat-icon svgIcon="analytics"></mat-icon>
        </a>
        <button
          type="button"
          [disabled]="editor.loading$ | async"
          (click)="toggleAnimationPanel('animation')"
          class="action-button"
          mat-icon-button
          [matTooltip]="'Animation' | trans"
          [class.active]="animationActive$ | async"
        >
          <mat-icon svgIcon="animation"></mat-icon>
        </button>
        <button
          type="button"
          (click)="toggleAnimationPanel('leapLink')"
          [disabled]="editor.loading$ | async"
          class="action-button"
          mat-icon-button
          [matTooltip]="'Leap Link' | trans"
          [class.active]="leapActive$ | async"
        >
          <mat-icon svgIcon="shortcut"></mat-icon>
        </button>
        <button
          type="button"
          (click)="toggleAnimationPanel('schedule')"
          [disabled]="editor.loading$ | async"
          class="action-button schedule-action-btn"
          mat-icon-button
          [matTooltip]="'Schedule' | trans"
          [class.active]="scheduleActive$ | async"
        >
          <mat-icon svgIcon="more-time"></mat-icon>
        </button>
        <button
          type="button"
          (click)="editor.maybeDeleteContentItem(link)"
          [disabled]="editor.loading$ | async"
          class="action-button delete-action"
          mat-icon-button
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="locked-notif" *ngIf="link.active_locked && !(activeSlideOutPanel$ | async)">
    <div class="locked-notif-msg" trans>This link is inactive due to its schedule.</div>
  </div>

  <biolink-slideout-panel
    [title]="'Animation'"
    (closed)="activeSlideOutPanel$.next(null)"
    *ngIf="(activeSlideOutPanel$ | async) === 'animation'"
    @slideOutPanelAnimation
  >
    <animation-selector formControlName="animation"></animation-selector>
  </biolink-slideout-panel>

  <biolink-slideout-panel
    [title]="'Leap Link'"
    (closed)="activeSlideOutPanel$.next(null)"
    *ngIf="(activeSlideOutPanel$ | async) === 'leapLink'"
    @slideOutPanelAnimation
  >
    <leap-link-panel formControlName="image"></leap-link-panel>
  </biolink-slideout-panel>

  <biolink-slideout-panel
    title="Thumbnail"
    (closed)="activeSlideOutPanel$.next(null)"
    *ngIf="(activeSlideOutPanel$ | async) === 'image'"
    @slideOutPanelAnimation
  >
    <link-thumbnail-panel formControlName="image"></link-thumbnail-panel>
  </biolink-slideout-panel>

  <biolink-slideout-panel
    title="Schedule Link"
    (closed)="activeSlideOutPanel$.next(null)"
    *ngIf="(activeSlideOutPanel$ | async) === 'schedule'"
    @slideOutPanelAnimation
  >
    <p [transValues]="{resource: 'link'}" class="schedule-description" trans>
      Enter a date when :resource should be active. Both start and end dates are optional.
    </p>
    <div class="inline-inputs-container">
      <div class="input-container" permission-aware-input-container="expiration">
        <datetime-input id="bio_exp_at" formControlName="activates_at" trans
          >Start Date</datetime-input
        >
      </div>
      <div class="input-container" permission-aware-input-container="expiration">
        <datetime-input id="bio_act_at" formControlName="expires_at">End Date</datetime-input>
      </div>
    </div>
  </biolink-slideout-panel>
</ng-container>
